import d3 from "./d3.min.js";
import * as topojson from "./topojson.min.js";
import { geoAlbersUsaPr } from "./geoAlbersPRprojection.js";
//
// Load the JSON data

//let boundaries = "./countybounds.json";
let boundaries = "/themes/earlycheck/staticData/countybounds.json";
//this varies my map boundary file
// console.log("boundaries", boundaries);

let measureval = "Value";

let measureCat = "Cat";

let threecolors = ["#f2d7dc", "#a82136", "#2e020a"];

let spectrum = d3.quantize(d3.interpolateRgbBasis(threecolors), 4);



let colors = d3.scaleLinear().range(spectrum);

let numFormat = d3.format(".0f");

// this is redundant from resultsDashPies. pass along instead
//fips code location in data file
let dataLocCode = "countyName";

function mapLocCode(d) {
  return d.properties.GEOID;
  //   return d.id;
}

async function getBoundaries() {
  let counties = await d3.json(window.location.origin + boundaries);

  return counties;
}

export const returnedBounds = getBoundaries();

export function initialMap(mapContainer, counties, dataLocCode) {
  //mapContainer.style('pointer-events', 'none')

  const width = 942.7924311762474;
  const height = 496.9298966319916;

  const tooltip = mapContainer
    .append("div")
    // .attr("class", "tooltip")
    .attr("id", "maptooltip");
  //        .style("opacity", 0);

  mapContainer
    .append("div")
    .attr("class", "col col-12")
    .append("span")
    .attr("class", "small instruct")
    .html("<i>Hover on map for detail.</i>");

  let svg = mapContainer
    .append("div")
    .attr("class", "col col-12 col-md-8 svgholder")
    .append("svg:svg")
    .attr("viewBox", `0 0 ${width} ${height}`)
    .style("display", "block")
    .style("margin", "0 -14px")
    .attr("class", "mapsvg");

  // let mapExtras = d3
  //   .select("#testIso")
  let mapExtras = mapContainer
    .append("div")
    //  .attr("class", "row d-flex justify-content-between")
    .attr("class", "col col-12 col-md-4")
    .attr("id", "mapExtras")
    .append("div")
    //  .attr("class", "row d-flex justify-content-between")
    .attr("class", "row")

  let zoombutton = mapContainer
  .select(".svgholder")
  .append("div")
  .attr("class", "row")
  .append("div")
  .attr("class", "col col-12 d-flex")
    // .select(".svgholder")
    .append("button")
    .attr("class", "w-auto ms-auto zoombutton btn btn-primary")
    .attr("id", "resetbutton")
    // .style("position", "relative")
    // .style("left", "100%");

  zoombutton
    .append("span")
    //.attr("class", "instruct")

    .html("reset zoom");

  makeLegend( mapExtras, 300, 70);

  const g = svg.append("g").attr("class", "boundaries");

  var projection = geoAlbersUsaPr().scale(6500).translate([-1050, -20]);

  //original
  // const path = d3.geoPath()
  //withPR
  const path = d3.geoPath(projection);

  //    const features = topojson.feature(counties,  counties.objects.counties).features
  const features = topojson.feature(
    counties,
    counties.objects.cb_2023_us_county_20m
  ).features;

  // console.log("f", features);

  //    const NCfeatures = features.filter(d => d.properties.STUSPS === "NC")
  //      const NCfeatures = features.filter(d => d.id.substring(0,2) === "37")

  //     const NCfeatures = features
  //    console.log('NCfeatures', NCfeatures)
  const polygon = g
    .append("g")
    .attr("class", "countiesg")
    .selectAll("g")
    .data(features)
    .enter()
    .append("g")
    .attr("class", "countyg")
    .style("transform", "rotate(10deg)")
    .style("transform-origin", "center")
    .append("path");

  //    polygon.filter(d => d.properties.STUSPS === "NC");

  var centroids = topojson
    //    .feature(counties, counties.objects.counties)
    .feature(counties, counties.objects.cb_2023_us_county_20m)
    .features.map(function (feature) {
      // console.log('feature', feature)
      // console.log('path', path)
      return path.centroid(feature);
    });
  // console.log("centroids", centroids);

  polygon
    .attr("d", path)
    .attr("class", "polygon counties")
    .attr("data-fips", (d) => d.id)
    .attr("id", (d) => d.properties["NAMELSAD"])
    .attr("id", (d) => d.properties["NAMELSAD"])
    // zero and no data are equivalent for this purpose, so use zero color
    .attr("fill", "#e8f3f6");

  // ugly- can't get centroid to work on single datum
  polygon.each((d, i) => {
    d.centroid = centroids[i];
  });

  //let tooltip = d3.select('#maptooltip')

  polygon;
  //        .on("mouseenter", function (d) {
  //                d3.select(this).classed("hovered", true);
  //
  //
  //
  //                tooltip.html("testing")
  //
  //                tooltip.transition().duration(300).style("opacity", 1);
  //
  //                console.log("mouseover", d3.select(this))
  //
  //
  //                console.log("hovered?", d3.select(this).classed("hovered"))
  //                //             polygon.moveToBack()
  //                d3.select(this.parentNode).raise()
  //
  //                let locData = d3.select(this).data();
  //
  //                d3.selectAll(".legendrows").classed("hovered", false);
  //                // add one to adjust for forced zero entry to legend
  //                d3.selectAll(".legendrows").filter((d, i) => i === locData[0].colorBin + 1).classed("hovered", true);
  //
  //                console.log('locData', locData)
  //                if (
  //                    locData &&
  //                    locData[0] &&
  //                    locData[0].result
  //
  //                ) {
  //
  //                    tooltip.html(function (d) {
  //                        return locData[0].result.DisaggregationValue + ": " + locData[0].result[measureval]
  //                    })
  //
  //                } else {
  //                    tooltip.html(function (d) {
  //                        return locData[0].properties.NAMELSAD + ": 0"
  //                    })
  //                }
  //
  //
  //            }
  //
  //        )
  //        .on("mousemove", (event) => {
  //            let loc = d3.select(this);
  //            tooltip
  //                .style("left", d3.pointer(event, loc.node())[0] + "px")
  //                .style("top", d3.pointer(event, loc.node())[1] + "px");
  //        })
  //        .on("mouseleave", function (d, i) {
  //            d3.select(".active").moveToFront();
  //            d3.select(this).classed("hovered", false);
  //            d3.selectAll(".legendrows").classed("hovered", false);
  //
  //            tooltip.transition().duration(300).style("opacity", 0);
  //        });
  // .on("click", clicked);

  svg
    .append("g")
    .attr("id", "outOfState")
    .attr("transform", `translate(${width - 50} , ${height - 50})`);

  var zoom = d3
    .zoom()
    .scaleExtent([1,8])
    .translateExtent([
     [-width / 2, -height / 2],
     [width * 1.5, height * 1.5]
   ])
  
    .on("zoom", function (event) {
      g.selectAll("path").attr("transform", event.transform);
      //
      //            // Check if '.detailg' elements exist
      //            if (d3.selectAll(".detailg").node()) {
      //                // Update the positions of '.detailg' elements
      //                d3.selectAll(".detailg").attr("transform", (d) => {
      //                    // Calculate the new centroid position
      //                    let newCentroid = event.transform.apply([
      //            d.centroid[0],
      //            d.centroid[1],
      //          ]);
      //
      //                    console.log("newCentroid", newCentroid);
      //                    return "translate(" + newCentroid[0] + "," + newCentroid[1] + ")";
      //                });
      //            }
    }); // end on zoom

  var recenter = d3
    .zoom()
    // .scaleExtent([1, 8])

    .on("zoom", function (event) {
      g.selectAll("path").attr("transform", event.transform);
    });

  svg.call(zoom);

  d3.select("#resetbutton").on("click", reset);

  function reset(event, d) {
    svg.transition().duration(750).call(zoom.transform, d3.zoomIdentity);
  }

  $("#mapButton").hide();
}
//end initial map

export function updateMap(mapContainer, dataToMap) {
  // console.log("dataToMap in update", dataToMap);
  //    threecolors = ["#f2d7dc", "#a82136", "#2e020a"];
  threecolors = ["#afd8db", "#59a5b1", "#005663"];

  // update color range for new measure selection
  spectrum = d3.quantize(d3.interpolateRgbBasis(threecolors), 4);

  d3.select("#legendTitle").html(
    "Number " + dataToMap[0][measureCat].toLowerCase()
  );

  // console.log("measureval", measureval);
  // console.log("threecolors", threecolors);

  colors = d3.scaleQuantile().range(spectrum);

  // console.log("colors.range()", colors.range());

  const outOfStateData = dataToMap.filter(
    (d) =>
      d["DisaggregationCategory"] === "State" &&
      d["DisaggregationValue"] !== "NC"
  );

  const outOfStateSum = d3.sum(outOfStateData, (d) => d.Value);

  // console.log("outOfStateData", outOfStateData);

  // console.log("outOfStateSum", outOfStateSum);

  let g = d3.selectAll(".boundaries");

  const polygon = mapContainer.select(".countiesg").selectAll("path");

  // console.log("polygon", polygon);

  // console.log("polygon._groups", polygon._groups);

  // console.log("dataToMap", dataToMap);

  //  measureval = newmeasureval

  //     colors.domain(
  //       d3.extent(
  //         [...dataToMap].map(function (d) {
  //           console.log("d", d);
  //           return +d[measureval];
  //         })
  //       )
  //     );

  // redefs needed in update
  // const polygon = mapContainer.select('svg').select('g').selectAll("path")

  function stateZoom(selectPath) {
    const [[x0, y0], [x1, y1]] = polygon.bounds(
      selectPath._groups[0][0].__data__
    );

    globals.mapSvg
      .transition()
      .duration(750)
      .ease(d3.easeQuadOut)
      .call(
        globals.zoom.transform,
        d3.zoomIdentity
          .translate(globals.width / 2, globals.height / 2)
          .scale(
            Math.min(
              8,
              0.9 /
                Math.max((x1 - x0) / globals.width, (y1 - y0) / globals.height)
            )
          )
          .translate(-(x0 + x1) / 2, -(y0 + y1) / 2)
      );
  }
  var zoom = d3
    .zoom()
    .scaleExtent([1, 30])

    .on("zoom", function (event) {
      g.selectAll("path").attr("transform", event.transform);

      // Update the positions of '.detailg' elements
      d3.selectAll(".detailg").attr("transform", (d) => {
        // Calculate the new centroid position
        let newCentroid = event.transform.apply([d.centroid[0], d.centroid[1]]);
        // console.log('d.centroid lower zoomdef', d.centroid )
        // console.log('newCentroid lower zoomdef', newCentroid )
        return "translate(" + newCentroid[0] + "," + newCentroid[1] + ")";
      });

      // console.log("newCentroid", newCentroid);

      stateZoom(g.selectAll("path"));
    }); // end on zoom

  var recenter = d3
    .zoom()
    .scaleExtent([1, 8])

    .on("zoom", function (event) {
      g.selectAll("path").attr("transform", event.transform);
    }); // end on zoom

  // end redefs needed in update

  // let testResult = [...dataToMap].find((item) => {
  //   return item[dataLocCode] === "02351";
  // });

  // console.log(" testResult", testResult);

  // let testResult2 = [...dataToMap].find((item) => {
  //   return item[dataLocCode] == "17125";
  // });

  // console.log(" testResult2", testResult2);

  polygon
    .each((d) => {
      // console.log("d in pair poly", d);
      // console.log("mapLocCode(d)", mapLocCode(d));
      //      //            console.log('d[mapLocCode]', d[mapLocCode])

      let result = [...dataToMap].find((item) => {
        // console.log("item", item[dataLocCode]);

        return item[dataLocCode] === mapLocCode(d);
      });

      //  console.log('centroid', centroid)
      if (result?.length > 0) {
        // console.log("result", result);
        // console.log("result[measureval]", result[measureval]);
        result[measureval] = parseFloat(result[measureval]);
      }
      d.result = result;
    })
    .classed("hasdata", (d) => d.result);

  // .transition()
  // .duration(220)

  //ensure counties with data are on top
  // d3.selectAll('polygon.counties').moveToBack()

  //for jensk breaks, both range and domain after data pairing?

  //      let fillableCounties = polygon._groups.filter((d) => {
  //          console.log('d in fillableCounties', d)
  //          return d[0]._data_.result && d[0]._data_.result[measure]});
  //  console.log("fillableCounties", fillableCounties);
  //
  let fillableCounties = mapContainer
    .select(".countiesg")
    .selectAll(".hasdata");
  // console.log("fillableCounties", fillableCounties);

  let CountyDatavals = fillableCounties.data();
  // console.log("CountyDatavals", CountyDatavals);
  // console.log("measureval", measureval);

  // get the data for those counties. NEW  remove zero values
  // var fillablevals = CountyDatavals.map((d) => {
  //   return parseFloat(d.result[measureval]);
  // }).filter((d) => d !== 0);

  // get the data for those counties. NEW  remove zero values
  let fillablevals;

  fillablevals = CountyDatavals.map((d) => {
    return parseFloat(d.result[measureval]);
  }).filter((d) => d !== 0);

  // console.log("fillablevals", fillablevals);
  // console.log("d3.extent(fillablevals)", d3.extent(fillablevals));
  // set the color domain to the extent of the fillable values, not full data domain

  //  let breaks = [];
  //
  //  console.log("cl", colors.range().length);
  //
  //  if (Math.abs(d3.extent(fillablevals)[0] - d3.extent(fillablevals)[1]) !== 0) {
  //    breaks = ss.jenks(
  //      fillablevals.map((d) => d),
  //      colors.range().length
  //    );
  //  }
  //
  //          // Ensure breaks are unique
  //breaks = breaks.filter((value, index, self) => self.indexOf(value) === index);
  //
  //if (breaks.length < 7) {
  //  // If we have fewer than 7 unique breaks, adjust the last break
  //  breaks[breaks.length - 1] = breaks[breaks.length - 1] + 1;
  //}
  //
  //
  //
  //
  //  console.log("breaks", breaks);
  //  if (breaks && breaks.length > 0) {
  ////    console.log(" breaks[5]", breaks[5]);
  ////    console.log("  breaks[5] + 1", breaks[5] + 1);
  ////    // values are colored based on the largest break which they are smaller than, so add one to the last break
  ////    // breaks[breaks.length - 1] =
  ////    breaks[breaks.length - 1] + breaks[breaks.length - 1] * 0.00001;
  //
  //    //is the addition to last break necessary? Here range had 6 colors, domain has 7 vals. First break is bottom of range-so doesn't appear as top of a color bin to pair with.
  //    colors.domain(breaks);
  //  } else {
  //

  colors.domain(d3.extent(fillablevals));
  //  }

  // console.log("colors.domain()", colors.domain());
  // console.log("colors.range()", colors.range());
  //add projection again
  //    let projection = geoAlbersUsaPr().scale(1100).translate([487.5, 305]);
  var projection = geoAlbersUsaPr().scale(6500).translate([-1050, 10]);

  polygon
    .attr("fill", (d) => {
      return d.result && d.result[measureval]
        ? parseFloat(d.result[measureval]) === 0
          ? "#e8f3f6"
          : colors(d.result[measureval])
        : // zero and no data are equivalent for this purpose, so use zero color

          "#e8f3f6";
      //     console.log("d in fill", d);
    })
    //if needing settings for no data
    //        .attr("stroke", (d) => {
    //            return d.result ? "#fff" : "#7e7e7e";
    //        })
    //stroke color done w css to change on hover
    .on(
      "end",
      updateLegend(mapContainer.select(".legend"), fillablevals, colors)
    );

  polygon.each((d) => {
    let colorIndex;
    if (d.result && d.result[measureval]) {
      //console.log("colors.range()", colors.range());
      let assignedColor = colors(d.result[measureval]);
      colorIndex = colors.range().indexOf(assignedColor);
      d.colorBin = colorIndex;
    } else {
      //d.colorBin = "nodataColor";
      d.colorBin = -1;
    }
  });

  let tooltip = d3.select("#maptooltip");

  polygon
    .on("mouseenter", function (d) {
      d3.select(this).classed("hovered", true);

      tooltip.html("testing");

      tooltip.transition().duration(300).style("opacity", 1);

      // console.log("mouseover", d3.select(this));

      // console.log("hovered?", d3.select(this).classed("hovered"));
      //             polygon.moveToBack()
      d3.select(this.parentNode).raise();

      let locData = d3.select(this).data();

      d3.selectAll(".legendrows").classed("hovered", false);
      // add one to adjust for forced zero entry to legend
      d3.selectAll(".legendrows")
        .filter((d, i) => i === locData[0].colorBin + 1)
        .classed("hovered", true);

      // console.log("locData", locData);
      if (locData && locData[0] && locData[0].result) {
        tooltip.html(function (d) {
          return (
            locData[0].result.DisaggregationValue +
            ": " +
            locData[0].result[measureval]
          );
        });
      } else {
        tooltip.html(function (d) {
          return locData[0].properties.NAMELSAD + ": 0";
          // return locData[0].properties.name + ": 0"
        });
      }
    })
    .on("mousemove", (event) => {
      let loc = d3.select(this);
      tooltip
        .style("left", d3.pointer(event, loc.node())[0] + "px")
        .style("top", d3.pointer(event, loc.node())[1] + "px");
    })
    .on("mouseleave", function (d, i) {
      d3.select(".active").moveToFront();
      d3.select(this).classed("hovered", false);
      d3.selectAll(".legendrows").classed("hovered", false);

      tooltip.transition().duration(300).style("opacity", 0);
    });

  let outOfStateG = d3.select("#outOfState");
  outOfStateG
    .append("rect")
    .attr("width", 270)
    .attr("x", -240)
    .attr("height", 50)
    .attr("y", -22)
    .attr("fill", "rgba(255, 255, 255, 0.850)");

  let oneStateG = outOfStateG
    .selectAll("g")
    .data(outOfStateData)
    .enter()
    .append("g")
    .attr("class", "innerg");

  //                //color inset for out of state
  //        let outOfState = d3.select("#outOfState")
  //        .data(outOfStateSum)
  //        .enter()
  //.append('g')
  //.attr('class', 'innerg')
  //
  //
  //               console.log('outOfState', outOfState)
  //

  oneStateG
    .append("circle")

    .attr("r", 14)
    .attr("cx", 0)
    .attr("cy", 2)
    .attr("fill", (d) => {
      // console.log("d for circle", d);
      // console.log("d[measureval]", d[measureval]);
      // console.log("colors(d.[measureval])", colors(d[measureval]));
      return d[measureval] === 0 ? "#fff" : colors(d[measureval]);
    })
    .attr("stroke", "#fff")
    .on("mouseenter", function (d) {
      let tip = mapContainer.select("#maptooltip");

      tip.transition().duration(300).style("opacity", 1);

      // console.log("mouseenter");
      d3.select(this).moveToFront();
      d3.select(this).classed("hovered", true);
      let locData = d3.select(this).data();

      // console.log("locData", locData);
      if (locData) {
        tip.html(function (d) {
          return locData[0].DisaggregationValue + ": " + locData[0][measureval];
        });
      } else {
        tip.html(": no data ");
      }
    })
    .on("mousemove", (event) => {
      let loc = d3.select(this);
      mapContainer
        .select("#maptooltip")
        .style("left", d3.pointer(event, loc.node())[0] + "px")
        .style("top", d3.pointer(event, loc.node())[1] + "px");
    })
    .on("mouseleave", function (d, i) {
      d3.select(".active").moveToFront();
      d3.select(this).classed("hovered", false);
      mapContainer
        .select("#maptooltip")
        .transition()
        .duration(300)
        .style("opacity", 0);
    });

  oneStateG
    .append("text")
    .text((d) => "South Carolina:")
    .attr("x", 0)
    .attr("y", 0)
    .attr("dx", -20)
    .attr("dy", 10)
    .attr("text-anchor", "end")
    .style("font-size", "1.3em");

  d3.selectAll(".hasdata").each(function () {
    d3.select(this.parentNode).moveToFront();
  });

  //    // Calculate the centroid of NC
  //    let ncCentroid = d3.geoCentroid({
  //        type: "FeatureCollection",
  //        features: ncCounties
  //    });
  //
  //    // Calculate the bounding box of the included counties
  //    let ncBounds = d3.geoBounds({
  //        type: "FeatureCollection",
  //        features: ncCounties
  //    });
  //    console.log('ncBounds', ncBounds)

  //    d3.selectAll(".countyg")
  //        .filter((d) => d.result)
  //        .append("g")
  //        .attr("class", "detailg")
  //        .attr("id", (d) => d.result[0] + "detail")
  //        // .datum(d =>
  //        //    { let parentPath = d3.select(this)._groups[0][0].parentNode
  //        //     return getBoundingBoxCenter(parentPath)
  //        // })
  //        // .attr('x', d => d[0])
  //        // .attr('y', d => d[1])
  //        .attr("transform", function (d) {
  //            // console.log('d',d)
  //            // console.log('d3.select(this)',d3.select(this))
  //            // console.log('d3.select(this)',d3.select(this)._groups[0][0].parentNode)
  //            console.log('d3.select(this).parent', d3.select(this).parentNode)
  //            let parentPath = d3.select(this)._groups[0][0].parentNode;
  //
  //            return "translate(" + d.centroid[0] + "," + d.centroid[1] + " )";
  //
  //            // return  "translate(" + getBoundingBoxCenter(parentPath)[0] + "," +  getBoundingBoxCenter(parentPath)[1] + " )"
  //        })
  //        .call(zoom);

  //mapContainer.style('pointer-events', 'all')
}

export function makeLegend(legendParent, legWidth, legHeight) {
  // console.log("make legend");

  // console.log("legendParent", legendParent);
  // console.log("colors.range()", colors.range());
  // console.log("colors.domain()", colors.domain());

  legendParent
    .append("h6")
    .attr("class", "col col-12 fw-bold fs-6")
    .attr("id", "legendTitle");

  legendParent.append("div").attr("class", "rowLegendHolder col col-12");
}

export function updateLegend(legend, legendData, colors) {
  // console.log("legend in update", legend);
  // console.log("d3.select(.legendsvg)", d3.select(".legendsvg"));
  // no longer using svg legend
  if (legend) {
    let legendData;
    // Prepend a new data item for zero value
    legendData = [
      [0, 0], // New data item for zero values
      ...colors.range().map(function (d) {
        d = colors.invertExtent(d);
        // if (d[0] == null) d[0] = x.domain()[0];
        // if (d[1] == null) d[1] = x.domain()[1];
        return d;
      }),
      //        [null, null],
    ];

    // console.log("legendData", legendData);

    let legendRows = d3
      .select(".rowLegendHolder")

      // let legendRows = rowLegendHolder
      .selectAll(".legendrows")
      //legendrects = legend.selectAll(".legendrect")
      //   .data(color.range());
      .data(legendData);

    // Handle exit selection: remove extra elements
    legendRows.exit().remove();

    // Enter selection: append new elements
    let legendRowsEnter = legendRows
      .enter()
      .append("div")
      .attr("class", "legendrows pt-1");

    // Merge enter selection with the existing selection
    legendRows = legendRowsEnter.merge(legendRows);

    // Update the properties of both new and existing elements
    legendRowsEnter
      .append("span")
      .attr("class", "color-bullet me-2")
      .text("█")
      .style("color", (d) => {
        if (!d[0]) {
          return "#ececec";
        } else {
          return colors(d[0]);
        }
      });

    legendRowsEnter.append("span").attr("class", "range-text");

    // Update existing elements
    legendRows
      .select(".color-bullet")
      .style("color", function (d) {
        // white for zero, no using no data on this proj
        return d[0] === 0 || d[0] === null ? "#fff" : colors(d[0]);
      })

      .style("border", function (d) {
        return d[0] === 0 ? "1px solid #bfbfbf" : "";
      });

    legendRows.select(".range-text").text((d, i) => {
      // console.log("i in leg text", i);

      if (i == legendRows.size() - 1) {
        // console.log("d in leg text", d);
        // the final entry
        return numFormat(d[0]) + " - " + numFormat(d[1]);
      } else if (d[0] == null) {
        return "no data";
      } else if (d[0] === 0 && d[1] === 0) {
        return "0"; // Text for zero values
      } else {
        //subract 1 ok w whole # counts
        return numFormat(d[0]) + " - " + numFormat(d[1] - 1);
      }
    });
  }
}
